import i18n from "i18n";
import * as Yup from "yup";

export interface AddStudentToEmailInviteBundleFormFields {
  studentEmail: string;
}

export const buildAddStudentToEmailInviteBundleFormSchema =
  (): Yup.SchemaOf<AddStudentToEmailInviteBundleFormFields> =>
    Yup.object({
      studentEmail: Yup.string()
        .email(
          i18n.t(
            "teacher-dashboard:invitationManagement.inviteBundleDetailsModal.addStudentToEmailInviteBundleForm.fields.studentEmail.errors.email",
          ),
        )
        .required(
          i18n.t(
            "teacher-dashboard:invitationManagement.inviteBundleDetailsModal.addStudentToEmailInviteBundleForm.fields.studentEmail.errors.required",
          ),
        ),
    }).required();
